import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { data } from 'jquery';
import { ToastrService } from 'ngx-toastr';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-media-library-upload',
  templateUrl: './media-library-upload.component.html',
  styleUrls: ['./media-library-upload.component.css']
})
export class ModuleMediaLibraryUploadComponent implements OnInit, OnDestroy {
  moduleid: number = 0;
  moduleInfo: any = {};
  currentUserIsAdmin: any = false;
  file: File;
  uploading: boolean = false;
  uploadpercentage: number = 0;
  mediatitle: string = '';// `Upload ${new Date().toLocaleString()}`;
  stop = false;
  submitted: boolean = false;
  schoolD :number = 0;

  constructor(private activatedroute: ActivatedRoute, public modulemanager: ModulemanagementService, private headerinfo: ComponentheaderService, private router: Router, private toastr: ToastrService, private util: UtilService) {
    this.headerinfo.setHeaderDisplay('Loading...', [], []);
    this.mediatitle = ''; //`Upload ${new Date().toLocaleString()}`;
  }


  async ngOnInit() {
    this.headerinfo.pageLoadingStarted(this);
    this.moduleid = parseInt(this.activatedroute.snapshot.queryParams.moduleid);
    const data: any = await this.modulemanager.getModuleDetails(this.moduleid).toPromise();
    this.moduleInfo = data.moduleinfo;
    this.currentUserIsAdmin = data.isViewerAdmin;
    const schoolName: string = data.schoolName;
    const schoolid: number = data.schoolID;
    
    let moduleDisplayName = this.moduleInfo.name;
    if (this.moduleInfo.courseCode) {
      moduleDisplayName += ` (${this.moduleInfo.courseCode})`;
    }

    this.headerinfo.setHeaderDisplay(
      'Upload Media',
      [

        // {displaytext: schoolName, route: `/user/schoolhome`, params: {schoolID: schoolid}}, 
        { displaytext: "Course", route: `/user/moduledetails`, params: { moduleID: this.moduleid } },
        { displaytext: 'Media Library', route: '/user/modulemedialibrary', params: { moduleid: this.moduleid } },
        { displaytext: 'Upload Media', route: this.activatedroute.snapshot.url.join('/'), params: this.activatedroute.snapshot.queryParams }
      ],
      []);

      this.headerinfo.pageLoadingDone(this);

      
      this.schoolD = data.schoolID;
     
  }

  // async submit(event: Event) {
  //   if (!this.mediatitle) {
  //     this.toastr.error('Title not set');
  //   } else {
  //     // this.submitted = true;
  //     // event.preventDefault();
  //     // this.uploading = true;
  //     // await this.uploadMediaFile().catch(() => {
  //     //   this.uploading = false;
  //     // });
  //     // this.uploading = false;
  //     // this.toastr.success('Media file uploaded. Edit your lesson notes to add it to your content');
  //     // this.router.navigate(['/user/modulemedialibrary'], { queryParams: { moduleid: this.moduleid } });
  //   }
  // }
  async submit(event: Event){
    if (!this.mediatitle) {
          this.toastr.error('Title not set');
          return;
    }
    this.submitted = true;
    //debugger;
    event.preventDefault();
    this.uploading = true;

    const response: boolean = await this.modulemanager.getMediaStatus(this.schoolD, this.file.size).toPromise();
      
    if(response){
      try{
        await this.uploadMediaFile();
        this.toastr.success('Media file uploaded. Edit your lesson notes to add it to your content');
        this.router.navigate(['/user/modulemedialibrary'], { queryParams: { moduleid: this.moduleid } });
      }
      catch(error){
        this.toastr.error(error);
      }
      finally{
        this.uploading = false;
      }
      
    }else{
      this.toastr.error('Upload Failed. You have exceeded your media storage limit');
    }
        
      
    

    // await this.uploadMediaFile().catch(() => {
    //   this.uploading = false;
    // });
    // this.uploading = false;
    // this.toastr.success('Media file uploaded. Edit your lesson notes to add it to your content');
    // this.router.navigate(['/user/modulemedialibrary'], { queryParams: { moduleid: this.moduleid } });
  }

  async uploadMediaFile() {
    const f = this.file;
    const uploadid = Math.random().toString(36).substring(7);
    const chunksize = 1024 * 1024 * 0.5;

    const readFileChunk = function (_offset, length, _file) {
      return new Promise<ArrayBuffer>(function (accept, reject) {
        var r = new FileReader();
        r.onload = function (evt) {
          //debugger;
          accept(<ArrayBuffer>evt.target.result);
        }
        var blob = _file.slice(_offset, length + _offset);
        r.readAsArrayBuffer(blob);
      });
    };


    let offset: number = 0;
    for (let i = 0; !this.stop; i++) {
      let buffer: ArrayBuffer = await readFileChunk(offset, chunksize, f);

      if (buffer.byteLength > 0) {
        try {
          //debugger;
          const blob = new Blob([buffer]);
          //console.log(f.size);
          await this.modulemanager.uploadMediaFilePart(this.moduleid, uploadid, blob, i).toPromise();
          try {
            let percentage = ((i + 1) * chunksize) / f.size * 100;
            if (percentage > 100) {
              percentage = 100;
            }
            percentage = Math.floor(percentage);
            this.uploadpercentage = percentage;
            if (!this.stop) {
              this.headerinfo.setLoadingProgress(percentage);
            }
          } catch (error) {
            console.log(error);
          }
        }
        catch (error) {
          i--;
          continue;
        }
      }
      //debugger;
      offset += buffer.byteLength;
      if (buffer.byteLength == 0) {
        //debugger;
        await this.modulemanager.finishMediaFileUpload(this.moduleid, uploadid, f.name, f.type, this.mediatitle, f.size).toPromise();
        return;
      }
    }
  }

  selectedFileValid(): boolean {
    return this.file !== undefined && this.file !== null;
  }

  fileSelected(files: FileList) {
    if (files.length > 0) {
      this.file = files[0];
    }
    else {
      this.file = null;
    }
  }

  ngOnDestroy(): void {
    this.stop = true;
  }
}
